import { createLogic, createLogicMiddleware } from 'redux-logic'
import { notifyMonitors } from '../actions/toolbar'
import { changeMonitor } from '../actions/webrtcConnection'

export const ALL_MONITORS = 'all'

export const selectActiveMonitorLogic = createLogic({
  type: [notifyMonitors],
  latest: true,

  processOptions: {
    dispatchReturn: true,
  },

  process ({ action }) {
    const monitors = action.payload

    const activeMonitorId = monitors.length > 1 ? ALL_MONITORS : monitors[0].id
    return changeMonitor(activeMonitorId)
  }
})

export const selectActiveMonitorLogicMiddleware = createLogicMiddleware([selectActiveMonitorLogic])
